import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[onlyLettersAndNumbers]'
})

export class OnlyLettersAndNumbersDirective {
    private regex: RegExp = new RegExp(/[^A-Za-z0-9áÁãÃâÂàÀéÉêÊíÍóÓõÕôÔúÚçÇ ]/g);
    // Allow key codes for special events. Reflect :
    // Backspace, tab, end, home
    private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home'];

    constructor(private el: ElementRef) {
    }

    @HostListener('keypress', ['$event'])
    onkeypress(event: KeyboardEvent) {
        // Allow Backspace, tab, end, and home keys
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }

        const current: string = this.el.nativeElement.value;
        // We need this because the current value on the DOM element
        // is not yet updated with the value from this event
        const next: string = current.concat(event.key);
        if (next && String(next).match(this.regex)) {
            event.preventDefault();
        }
    }

    @HostListener('paste', ['$event'])
    blockPaste(event: KeyboardEvent) {
        const current: string = this.el.nativeElement.value;
        const next: string = current.concat(event['clipboardData'].getData('Text'));

        if (next && String(next).match(this.regex)) {
            event.preventDefault();
        }
    }

    @HostListener('dragover', ['$event'])
    onDragOver(event: any) {
        event.dataTransfer.dropEffect = 'none';
        return event.preventDefault();
    }
}
